import { profilePictureFallback } from '@tools/profile-picture-fallback';
import { anchor } from './anchor';

/**
 * @description Load atoms, useful when you change the DOM and need
 * to reload the JS customization layer
 */

export const loadAtoms = () => {
  profilePictureFallback();
  anchor();
};
